module.exports = __webpack_public_path__ + "app/layouts/app/header-2S2u1wz-.html";